import { writable } from 'svelte/store'

export const ModalStore = Modal()
export const FloatBoxStore = FloatBox()
export const PolygonStore = writable(null)
export const LatLngStore = writable(null)

export const AccountStore = Model('Account')
export const ChargeStore = Model('Charge')
export const CreditStore = Model('Credit')
export const DriverStore = Model('Driver')
export const FacturamaClientStore = Model('FacturamaClient')
export const FixedpriceStore = Model('Fixedprice')
export const InvoiceClientStore = Model('InvoiceClient')
export const InvoiceStore = Model('Invoice')
export const LocationStore = Model('Location')
export const MerchandiseStore = Model('Merchandise')
export const PackageStore = Model('Package')
export const PickupStore = Model('Pickup')
export const PrepaidStore = Model('Prepaid')
export const PricingStore = Model('Pricing')
export const QuotationStore = Model('Quotation')
export const RefundStore = Model('Refund')
export const SessionStore = Model('Session')
export const ShipmentStore = Model('Shipment')
export const TicketStore = Model('Ticket')
export const TransportStore = Model('Transport')
export const UserStore = Model('User')
export const WalletStore = Model('Wallet')
export const ZoneStore = Model('Zone')

export const AccountsStore = Collection('Accounts')
export const ChargesStore = Collection('Charges')
export const CreditsStore = Collection('Credits')
export const DriversStore = Collection('Drivers')
export const FixedpricesStore = Collection('Fixedprices')
export const InvoicesStore = Collection('Invoices')
export const LocationsStore = Collection('Locations')
export const MerchandisesStore = Collection('Merchandises')
export const PackagesStore = Collection('Packages')
export const PickupsStore = Collection('Pickups')
export const PrepaidsStore = Collection('Prepaids')
export const PricingsStore = Collection('Pricings')
export const RefundsStore = Collection('Refunds')
export const ShipmentsStore = Collection('Shipments')
export const TicketsStore = Collection('Tickets')
export const TrackingsStore = Collection('Trackings')
export const TransportsStore = Collection('Transports')
export const UsersStore  = Collection('Users')
export const ZonesStore = Collection('Zones')

function Modal(state = null) {

    const {subscribe, update, set} = writable(state)

    function close() {
        set(null)
    }

    function open(action) {
        set(action)
    }

    return {
        subscribe,
        update,
        set,
        close,
        open
    }
}

function FloatBox(state = null) {

    const {subscribe, update, set} = writable(state)

    function close() {
        set(null)
    }

    function open(action) {
        set(action)
    }

    return {
        subscribe,
        update,
        set,
        close,
        open
    }
}

function Model(name, state = null) {

    const {subscribe, update, set} = writable(state)

    function modalCreate(data = null) {
        ModalStore.set(`${name}Create`)
        if(data) set(data)
    }

    function modalRead(data = null) {
        ModalStore.set(`${name}Read`)
        if(data) set(data)
    }

    function modalUpdate(data = null) {
        ModalStore.set(`${name}Update`)
        if(data) set(data)
    }

    function modalDelete(data = null) {
        ModalStore.set(`${name}Delete`)
        if(data) set(data)
    }

    function modalOpen(modalName, data = null) {
        ModalStore.set(modalName)
        if(data) set(data)
    }

    function modalClose() {
        ModalStore.set(null)
        set(null)
    }

    return {
        subscribe,
        update,
        set,
        modalCreate,
        modalRead,
        modalUpdate,
        modalDelete,
        modalOpen,
        modalClose,
    }
}

function Collection(name, state = []) {

    const {subscribe, update, set} = writable(state)

    function modal(data, action) {
        ModalStore.set(`${name}${action}`)
        set(data)
    }

    function append(data, update) {
        return update(items => {
            items.unshift(data)
            return items
        })
    }

    function replace(data, update) {
        return update(items => {
            return items.map(item => {
                return item._id === data._id? data : item
            })
        })
    }

    function remove(dataId, update) {
        return update(items => {
            return items.filter(item => item._id != dataId)
        })
    }

    return {
        subscribe,
        update,
        set,
        modal,
        append: item => append(item, update),
        replace: item => replace(item, update),
        remove: itemId => remove(itemId, update)
    }
}